export default "//static.tradera.net/touchweb/static/output/images/bankid.81f2e99a.svg";